import type { PayloadAction } from '@reduxjs/toolkit';

import { SET_PURCHASE_PARAMS, type PurchaseParams } from './types';

const initialState: PurchaseParams = {
	plan: 'yearly',
	coupon: null,
	promotion: null,
	samsungGUID: null,
	guestPass: null,
	calmjwt: null,
	is30DayOverride: false,
	giftPrice: null,
	isUpdateBillingScreen: false,
};

export function purchaseParamsReducer(
	state = initialState,
	action: PayloadAction<PurchaseParams>,
): PurchaseParams {
	switch (action.type) {
		case SET_PURCHASE_PARAMS:
			return action.payload;
		default:
			return state;
	}
}
